var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { styled } from "../../theme";
export
/**
 * A group of buttons with additional styles provided by Eva.
 * ButtonGroup should contain Button components to provide a usable component.
 *
 * @extends React.Component
 *
 * @property {ReactElement<ButtonProps> | ReactElement<ButtonProps>[]} children -
 * Buttons to be rendered within the group.
 *
 * @property {string} appearance - Appearance of the component.
 * Can be `filled` or `outline`.
 * Defaults to *filled*.
 *
 * @property {string} status - Status of the component.
 * Can be `basic`, `primary`, `success`, `info`, `warning`, `danger` or `control`.
 * Defaults to *primary*.
 * Use *control* status when needed to display within a contrast container.
 *
 * @property {string} size - Size of the component.
 * Can be `tiny`, `small`, `medium`, `large`, or `giant`.
 * Defaults to *medium*.
 *
 * @property {ViewProps} ...ViewProps - Any props applied to View component.
 *
 * @overview-example ButtonGroupSimpleUsage
 * Button Group accepts buttons as child elements.
 *
 * @overview-example ButtonGroupAppearance
 * Appearance passed to group is also applied for grouped buttons.
 *
 * @overview-example ButtonGroupStatus
 * Same for status.
 *
 * @overview-example ButtonGroupSize
 * And size.
 *
 * @overview-example ButtonGroupOutline
 *
 * @overview-example ButtonGroupWithIcons
 */
let ButtonGroup = (_dec = styled('ButtonGroup'), _dec(_class = (_temp = class ButtonGroup extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getComponentStyle", source => {
      const {
        dividerBackgroundColor,
        dividerWidth
      } = source,
            containerParameters = _objectWithoutProperties(source, ["dividerBackgroundColor", "dividerWidth"]);

      return {
        container: _objectSpread(_objectSpread({}, containerParameters), {}, {
          borderWidth: containerParameters.borderWidth + 0.25
        }),
        button: {
          borderWidth: dividerWidth,
          borderColor: dividerBackgroundColor
        }
      };
    });

    _defineProperty(this, "isFirstElement", index => {
      return index === 0;
    });

    _defineProperty(this, "isLastElement", index => {
      return index === React.Children.count(this.props.children) - 1;
    });

    _defineProperty(this, "renderButtonElement", (element, index, style) => {
      const {
        appearance,
        size,
        status
      } = this.props;
      const {
        borderRadius
      } = style.container;
      const {
        borderWidth,
        borderColor
      } = style.button;
      const shapeStyle = !this.isLastElement(index) && {
        borderEndWidth: borderWidth,
        borderEndColor: borderColor
      };
      const startShapeStyle = this.isFirstElement(index) && {
        borderTopStartRadius: borderRadius,
        borderBottomStartRadius: borderRadius
      };
      const endShapeStyle = this.isLastElement(index) && {
        borderTopEndRadius: borderRadius,
        borderBottomEndRadius: borderRadius
      };
      return /*#__PURE__*/React.cloneElement(element, {
        key: index,
        appearance: appearance,
        size: size,
        status: status,
        style: [element.props.style, styles.button, shapeStyle, startShapeStyle, endShapeStyle]
      });
    });

    _defineProperty(this, "renderButtonElements", (source, style) => {
      return React.Children.map(source, (element, index) => {
        return this.renderButtonElement(element, index, style);
      });
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      children
    } = _this$props,
          viewProps = _objectWithoutProperties(_this$props, ["eva", "style", "children"]);

    const evaStyle = this.getComponentStyle(eva.style);
    return /*#__PURE__*/React.createElement(View, _extends({}, viewProps, {
      style: [evaStyle.container, styles.container, style]
    }), this.renderButtonElements(children, evaStyle));
  }

}, _temp)) || _class);
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    overflow: 'hidden'
  },
  button: {
    borderRadius: 0,
    borderWidth: 0
  }
});